import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, inject, OnInit, signal, ViewEncapsulation, WritableSignal } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { CreateRobReportComponent } from '@vessel-reports/rob/components/create-rob-report/create-rob-report.component';
import { RobReportDetailsComponent } from '@vessel-reports/rob/components/rob-report-details/rob-report-details.component';
import { RobReportType } from '@vessel-reports/rob/state/rob.types';

@Component({
  selector: 'rob-report-dialog',
  imports: [CreateRobReportComponent, RobReportDetailsComponent],
  templateUrl: './rob-report-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styles: `
    .mat-mdc-dialog-container .mdc-dialog__surface {
      padding: 0 !important;
      min-width: 300px !important;
    }
  `
})
export class RobReportDialogComponent implements OnInit {
  protected readonly translocoService: TranslocoService = inject(TranslocoService);

  type: WritableSignal<RobReportType> = signal('create-new');

  constructor(
    private _matDialogRef: MatDialogRef<RobReportDialogComponent>,
    private _changeDetector: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    if (this.data?.type === 'details') {
      this.type.set('details');
    }
  }

  onSaveCreate() {
    this.type.set('details');
  }

  onClose() {
    this._matDialogRef.close();
  }
}
